import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getUsers } from '../../services/user'

export const getEmployeesAction = createAsyncThunk('employees/get', async ({ fields }, { rejectWithValue }) => {
  try {
    const params = fields ? { fields } : {}
    const data = await getUsers(params)
    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const employeeSlice = createSlice({
  name: 'employee',
  initialState: {
    employees: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  extraReducers: {
    [getEmployeesAction.pending]: (state) => {
      state.isFetching = true
    },
    [getEmployeesAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getEmployeesAction.fulfilled]: (state, data) => {
      state.employees = data.payload
      state.isFetching = false
      state.isSuccess = true
      return state
    },
  },
})

export const employeeSelector = (state) => state.employees
